import React, { useMemo } from 'react';
import { KeyMetricChartData } from 'src/components/organisms/KeyMetricChart';
import { getAggregateLevelData } from 'src/features/MM/utils/getAggregateLevelData';
import { AggregateLevel } from 'src/types';
import { useMMDataContext } from '../../../contexts/MMDataContext';
import { KeyMetricItem } from 'src/features/MM/components/molecules/KeyMetricItem';
import { Icon } from 'src/components/atoms/Icon';
import { calculateTrendFromTimeSeries } from 'src/features/MM/utils/calculateTrendFromTimeSeries';

type MediaInvestmentProps = {
  aggregateLevel: AggregateLevel;
};

export const MediaInvestment: React.FC<MediaInvestmentProps> = ({
  aggregateLevel,
}) => {
  const { investments } = useMMDataContext();
  const keyMetricData: KeyMetricChartData = useMemo(() => {
    return {
      isLoading: investments.isLoading,
      isError: investments.isError,
      name: 'Media Investment',
      isEuro: true,
      summaryValue: investments.total,
      data: getAggregateLevelData(investments, aggregateLevel),
    };
  }, [investments, aggregateLevel]);

  const { upOrDown, upOrDownValue } = useMemo(() => {
    return calculateTrendFromTimeSeries(keyMetricData?.data ?? []);
  }, [keyMetricData?.data]);

  return (
    <KeyMetricItem
      title="Media Investment"
      upOrDown={upOrDown}
      upOrDownValue={upOrDownValue}
      value={keyMetricData.summaryValue}
      icon={<Icon iconName="finger-on-dollar" />}
    />
  );
};
